import React, { ReactNode } from 'react'
import { LoadingOutlined } from '@ant-design/icons'
import { twMerge } from 'tailwind-merge'

// TODO:
// as link

export type Props = {
  Icon?: ReactNode
  type?: 'button' | 'submit' | 'reset'
  color?: 'white' | 'blue'
  disabled?: boolean
  onClick?: () => void
  size?: 'default' | 'large' | 'x-large'
  loading?: boolean
  classes?: {
    root?: string
    loader?: string
    loaderContainer?: string
    content?: string
  }
}

export const ActionButton: React.FC<Props> = (props) => {
  const {
    Icon,
    type = 'button',
    children,
    color = 'blue',
    disabled,
    onClick,
    size = 'normal',
    loading,
    classes,
  } = props
  const canHandleClick = !loading && !disabled

  return (
    <button
      type={type}
      onClick={canHandleClick && onClick ? onClick : undefined}
      className={twMerge(
        'border rounded-full font-medium relative whitespace-nowrap',
        color === 'blue' && 'border-blue-800 bg-blue-800 text-white',
        color === 'white' && 'border-gray-300 bg-white text-gray-700',
        size === 'default' && 'text-sm leading-4 h-11 md:h-[34px]',
        size === 'large' && 'h-11 text-base leading-6 md:h-10',
        size === 'x-large' && 'text-base h-[50px] px-6',
        'border rounded-full font-medium relative whitespace-nowrap',
        loading && 'opacity-45',
        disabled && 'bg-gray-50 border-gray-200 text-gray-400',
      )}
    >
      {loading && (
        <div className={twMerge('pointer-events-none', color === 'blue' && 'opacity-60', classes?.loaderContainer)}>
          <LoadingOutlined className={twMerge('h-5', classes?.loader)} spin />
        </div>
      )}
      <div className={twMerge('grid grid-flow-col items-center gap-x-4', loading && 'invisible', classes?.content)}>
        {children}
        {Icon}
      </div>
    </button>
  )
}
